import { House } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";

export default function AdminHomeButton() {
  const navigate = useNavigate();
  const user = useAuth()?.user;
  const therapist = user?.role === "therapist";
  return <Button size="sm" variant="outline" onClick={() => navigate(therapist ? "/my-patients" : "/admin")}><House size={16} /> {therapist ? "Command Centre" : "Admin Home"}</Button>;
}
